module.exports = __webpack_public_path__ + "static/media/disclaimer_sinhala.d02efba8.md";